import React from "react";
import Layout from "../Layout/Layout";

const Hotel = () => {
  return <Layout></Layout>;
};

export default Hotel;
